import { Dispatch } from 'redux'
import { ActionType, AdministrationAction } from './actionTypes'
import { Employee, Settings, PaymentType, CashFund, Transaction, ExpenseType, Expense, Check, CreditCard, Tax, PaymentOrder, Ticket, CreditPayment, AdjustmentNote } from './types'
import { FiscalDocument } from '../../fiscal-documents'

export const setCurrentEmployee = (employee: Employee) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.SET_CURRENT_EMPLOYEE,
            payload: employee
        })
    }
}

export const clearTaxes = () => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.SET_TAXES,
            payload: []
        })
    }
}

export const updateTaxes = (taxes: Tax[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_TAXES,
            payload: taxes
        })
    }
}

export const removeTaxes = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_TAXES,
            payload: ids
        })
    }
}

export const clearSettings = () => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.SET_SETTINGS,
            payload: []
        })
    }
}

export const updateSettings = (settings: Settings[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_SETTINGS,
            payload: settings
        })
    }
}

export const clearCashFunds = () => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.SET_CASH_FUNDS,
            payload: []
        })
    }
}

export const updateCashFunds = (cashFunds: CashFund[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_CASH_FUNDS,
            payload: cashFunds
        })
    }
}

export const removeCashFunds = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_CASH_FUNDS,
            payload: ids
        })
    }
}

export const updateChecks = (checks: Check[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_CHECKS,
            payload: checks
        })
    }
}

export const removeChecks = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_CHECKS,
            payload: ids
        })
    }
}

export const clearCreditCards = () => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.SET_CREDIT_CARDS,
            payload: []
        })
    }
}

export const updateCreditCards = (creditCards: CreditCard[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_CREDIT_CARDS,
            payload: creditCards
        })
    }
}

export const removeCreditCards = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_CREDIT_CARDS,
            payload: ids
        })
    }
}

export const updateTransactions = (transactions: Transaction[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_TRANSACTIONS,
            payload: transactions
        })
    }
}

export const removeTransactions = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_TRANSACTIONS,
            payload: ids
        })
    }
}

export const clearEmployees = () => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.SET_EMPLOYEES,
            payload: []
        })
    }
}

export const updateEmployees = (employees: Employee[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_EMPLOYEES,
            payload: employees
        })
    }
}

export const removeEmployees = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_EMPLOYEES,
            payload: ids
        })
    }
}

export const clearPaymentTypes = () => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.SET_PAYMENT_TYPES,
            payload: []
        })
    }
}

export const updatePaymentTypes = (paymentTypes: PaymentType[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_PAYMENT_TYPES,
            payload: paymentTypes
        })
    }
}

export const removePaymentTypes = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_PAYMENT_TYPES,
            payload: ids
        })
    }
}

export const clearExpenseTypes = () => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.SET_EXPENSE_TYPES,
            payload: []
        })
    }
}

export const updateExpenseTypes = (expenseTypes: ExpenseType[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_EXPENSE_TYPES,
            payload: expenseTypes
        })
    }
}

export const removeExpenseTypes = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_EXPENSE_TYPES,
            payload: ids
        })
    }
}

export const updateExpenses = (expenses: Expense[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_EXPENSES,
            payload: expenses
        })
    }
}

export const removeExpenses = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_EXPENSES,
            payload: ids
        })
    }
}

export const updatePaymentOrders = (orders: PaymentOrder[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_PAYMENT_ORDERS,
            payload: orders
        })
    }
}

export const removePaymentOrders = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_PAYMENT_ORDERS,
            payload: ids
        })
    }
}

export const updateTickets = (tickets: Ticket[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_TICKETS,
            payload: tickets
        })
    }
}

export const removeTickets = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_TICKETS,
            payload: ids
        })
    }
}

export const selectTickets = (tickets: Ticket[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.SELECT_TICKETS,
            payload: tickets
        })
    }
}

export const updateCreditPayments = (creditPayments: CreditPayment[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_CREDIT_PAYMENTS,
            payload: creditPayments
        })
    }
}

export const removeCreditPayments = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_CREDIT_PAYMENTS,
            payload: ids
        })
    }
}

export const updateAdjustmentNotes = (adjustmentNotes: AdjustmentNote[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_ADJUSTMENT_NOTES,
            payload: adjustmentNotes
        })
    }
}

export const removeAdjustmentNotes = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_ADJUSTMENT_NOTES,
            payload: ids
        })
    }
}

export const updateFiscalDocuments = (fiscalDocuments: FiscalDocument[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.UPDATE_FISCAL_DOCUMENTS,
            payload: fiscalDocuments
        })
    }
}

export const removeFiscalDocuments = (ids: string[]) => {
    return (dispatch: Dispatch<AdministrationAction>) => {
        dispatch({
            type: ActionType.REMOVE_FISCAL_DOCUMENTS,
            payload: ids
        })
    }
}
